import React from 'react';
import moment from 'moment';
import { Col, Row, ButtonGroup, Button, Dropdown } from 'react-bootstrap';
import { isElasticLoad, usePermission } from '../../helpers/common';
import { toDisplayDateTimeString } from '../../helpers/moment-ex';
import { NumberLoader } from "../widgets/Loader";

export const CardMonitor = ({ children }) =>
    <div className="card-monitor">{children}</div>;

export const SummaryBox = ({ children }) =>
    <div className="card-grid">{children}</div>;

export const SummaryRow = ({ children }) =>
    <Row className="card-grid-row">{children}</Row>;

export const SummaryItem = ({ title, value, isLoading, unit, size = 4 }) =>
    <Col sm={size} className="card-grid-cell">
        <span>{title}</span>
        {unit && <div className="unit-label">{`(${unit})`}</div>}
        {isLoading ? <h6><NumberLoader /></h6> : <h6>{value}</h6>}
    </Col>;

export const TypeSelection = ({ onSelect, activeKey, params = null }) =>
    <div className="d-flex justify-content-center">
        <ButtonGroup size="sm" className="type-selection" toggle={true}>
            <Button variant={(activeKey === 1) ? "primary" : "default"} onClick={e => onSelect(1, e)} size="sm">Summary</Button>
            {
                params && (!params.hasOwnProperty("regionId") || !params.regionId) && <Button variant={(activeKey === 2) ? "primary" : "default"} onClick={e => onSelect(2, e)} size="sm">Graph</Button>
            }
        </ButtonGroup>
    </div>;

export const DottedMenu = ({ children }) =>
(<Dropdown className="ml-3 mr-1 analyze-dropdown-btn">
    <Dropdown.Toggle split variant="link">
        <i className="fa fa-ellipsis-v"></i>
    </Dropdown.Toggle>
    <Dropdown.Menu className="analyze-dropdown-menu">{children}</Dropdown.Menu>
</Dropdown>);

export const FarmOptions = ({ options, value, onSelect }) => {
    return (<DottedMenu>
        {options.map((item, i) =>
            <Dropdown.Item key={i} active={(item.plan_type_id === value) ? value : undefined}
                onSelect={() => onSelect(item)} >
                <i className="fa fa-circle" aria-hidden="true" /> {item.plan_type}
            </Dropdown.Item>)}
    </DottedMenu>);
}

export const CrewOptions = ({ onSelect }) => {
    const allow = usePermission();
    const isAllowWhatif = allow("whatif", "view");
    // const isAllowLoadHistory = allow("load-history", "view") ? !isElasticLoad() : false;

    return (isAllowWhatif) &&
        <DottedMenu>
            {isAllowWhatif &&
                <Dropdown.Item key={0} onSelect={() => onSelect("WhatIf")}>
                    <i className="fa fa-circle" aria-hidden="true" /> What If
                </Dropdown.Item>}
            {/* {isAllowLoadHistory &&
                <Dropdown.Item key={1} onSelect={() => onSelect("CrewLoadHistory")}>
                    <i className="fa fa-circle" aria-hidden="true" /> Load History
            </Dropdown.Item>} */}
        </DottedMenu>;
}

export const EGOptions = ({ onSelect }) => {
    const allow = usePermission();
    const isAllowLoadHistory = allow("load-history", "view") ? !isElasticLoad() : false;

    return isAllowLoadHistory &&
        <DottedMenu>
            <Dropdown.Item key={0} onSelect={() => onSelect("EgLoadHistory")}>
                <i className="fa fa-circle" aria-hidden="true" /> Load History
            </Dropdown.Item>
        </DottedMenu>;
}

export const CrewDropdown = ({ crews, selected, onSelect }) => {
    const options = crews.sort((a, b) => moment.utc(b.end_date).valueOf() - moment.utc(a.end_date).valueOf());
    const isSelected = e => (e.crew_uuid === selected.crew_uuid && e.start_date === selected.start_date);
    const isDropdownMenu = (options.length > 1);
    const selectedItems = options.filter(e => isSelected(e));
    const selectedItem = selectedItems.length > 0 ? selectedItems[0] : null;

    return (
        <Dropdown className="ml-2 dropdown-plan-type">
            <Dropdown.Toggle className={`btn-crew-selector ${!isDropdownMenu && "hide-btn"}`}>
                {selectedItem ? selectedItem.name : ""}
            </Dropdown.Toggle>
            {isDropdownMenu &&
                <Dropdown.Menu>
                    {options.map(e => {
                        const selected = isSelected(e);
                        const key = `${e.crew_uuid}${e.start_date}`;

                        return <Dropdown.Item
                            key={key}
                            eventKey={key}
                            onSelect={() => onSelect(e)}
                            active={selected}>
                            <span className={`bullet ${selected && "active"}`}>{e.name}</span>
                            <p className="display-date">
                                <i className="fa fa-calendar mr-1" />
                                {toDisplayDateTimeString(e.start_date, (moment.utc(e.start_date).year() === moment.utc().year()))}
                                <i className="fa fa-long-arrow-right i-arrow" aria-hidden="true"></i>
                                {e.alive ? "Now" : toDisplayDateTimeString(e.end_date, (moment.utc(e.end_date).year() === moment.utc().year()))}
                            </p>
                        </Dropdown.Item>;
                    })}
                </Dropdown.Menu>}
        </Dropdown>
    );
}